import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as api from './test-results-api';
import * as actions from './test-results-action-creators';

const sortTestResultsByDate = (testResults) => {
  testResults.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
};

const filterDuplicateTestResults = (testResults) => {
  const filtered = testResults
    .map((e) => e.labResultId)
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter((e) => testResults[e]).map((e) => testResults[e]);

  return filtered;
};

const testResultsLoadSuccess = (response, state) => {
  const testResults = response.map((tr) => {
    const result = {};
    result.labResultId = tr.labResultId;
    result.startDate = tr.startDate;
    result.requestingPhysician = tr.requestingPhysician;
    result.isReviewedByPatient = tr.isReviewedByPatient;

    result.labResultGroups = tr.testResultGroups.map((group) => {
      const resultGroup = {};
      resultGroup.testResultGroupId = group.testResultGroupId;
      resultGroup.groupDisplayName = group.groupDisplayName;
      return resultGroup;
    });

    return result;
  });
  sortTestResultsByDate(testResults);
  const filteredTestResults = filterDuplicateTestResults(testResults);

  const userPreferenceDateFilter = state.profile.user.preferences.PatientPortal_LabResultFilter_Date;

  return actions.testResultsLoadedSuccess(filteredTestResults, userPreferenceDateFilter);
};

export const loadNewTestResultsCount = (patientId) => (dispatch) =>
  api.getNewTestResultsCount(patientId).then(
    (response) => {
      dispatch(actions.newTestResultsCountLoadSuccess(response.data));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
  );

export const testResultRequestedForPrinting = (patientId, labResultId, callback) => (dispatch) =>
  api.getTestResultPdf(patientId, labResultId).then(
    (downloadedFile) => {
      if (callback) {
        callback(downloadedFile);
      }
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
  );

export const loadTestResultDetails = (patientId, testResultId) => (dispatch) =>
  api.getTestResultDetails(patientId, testResultId).then(
    (response) => {
      dispatch(actions.testResultDetailsLoadSuccess(response.data));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
  );

export const loadTestResults = (patientId) => (dispatch, getState) =>
  api.getTestResults(patientId).then(
    (response) => {
      dispatch(testResultsLoadSuccess(response.data, getState()));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
  );
